import React, { useState, useEffect, useRef } from "react";
import {Button, InputAdornment, Box, Typography} from "@mui/material";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Message} from "../../assets/images/icons";
import REST from "../../libs/API";
import { getText } from "../../libs/utils";

const ForgotPass = ({setActiveForm, setOpenDialog}) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const fieldRefs = useRef({});

  useEffect(() => {
    return () => setActiveForm('Auth');
  }, []);

  const handlerSubmit = () => {
    setLoading(true);
    REST.resetPassword(email)
    .then((data) => {
      if(!data.success) {
        window.showMessage(data.data[0].message);
      } else {
        window.showMessage(getText("restoreSuccessMsg"));
        setOpenDialog(false);
      }
      setLoading(false);
    });
  }

  return (
    <ValidatorForm
      onSubmit={handlerSubmit}
      instantValidate={false}
    >
      <Typography variant="caption" align="center" style={{maxWidth: 290, margin: "0 auto 7px", display: "inline-block"}}>
        {getText('recoveryH2')}
      </Typography>

      <TextValidator
        fullWidth
        placeholder="E-mail"
        variant="standard"
        name="email"
        ref={el => fieldRefs.current['email'] = el}
        onBlur={event => fieldRefs.current[event.target.name].validate(event.target.value)}
        onChange={(event) => setEmail(event.target.value)}
        validators={["required", "isEmail"]}
        errorMessages={[
          getText('reqiuredField'),
          getText('loginIncorectMail'),
        ]}
        value={email}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Message />
            </InputAdornment>
          ),
        }}
      />

      <Button 
        variant="contained"
        fullWidth
        size="large"
        type="submit"
        disabled={loading}
      >
        {getText('recoveryButton')}
      </Button>

      <Box textAlign="center">
        <span className="link-secondary" onClick={() => setActiveForm("Auth")}>
          {getText('regGoLogin')}
        </span>
      </Box>

    </ValidatorForm>
  );
};

export default ForgotPass;
